<template>
  <div class="footerMenu" v-bind:style="{display: display}">
    <b-container class="bv-example-row">
      <b-row>
        <b-col cols="12" md="8" class="menuFooter">
          <span v-if="footerloading" v-html="footermneuData.footermenu"></span>
        </b-col>

        <b-col cols="12" md="4" class="socialFooter">
          <ul class="fotSocial"><span><li id="menu-item-213" class="social-icon "><a target="_blank" alt="William O'Neil and Co. at Facebook" class="facebook" href="https://www.facebook.com/WilliamONeilCompany/"></a></li>
<li id="menu-item-226" class="social-icon linkedin "><a target="_blank" alt="William O'Neil and Co. at LinkedIn" class="linkedin" href="https://www.linkedin.com/company/william-o'neil---co.-inc."></a></li>
<p>©{{ new Date().getFullYear() }} William O'Neil + Company, Inc.</p></span></ul>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<style>
.footer {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
}
</style>
<script>
import { mapActions } from "vuex";
import { FOOTER_MENU } from "@/store/actions.type";
export default {
  created() {
    this.footermenu();
  },
  data() {
    return {
      footerloading: true,
      footerMenu: "footerMenu",
      footerhide: "",
      display: ""
    };
  },
  computed: {
    authstore() {
      return this.$store.state.auth;
    },
    footermneuData() {
      return this.authstore.footermenu;
    }
  },
  methods: {
    ...mapActions({
      featchfootermneu: "FOOTER_MENU"
    }),
    async footermenu() {
      if (JSON.parse(localStorage.getItem("rvTabs"))) {
        var length = JSON.parse(localStorage.getItem("rvTabs")).length;
        var tab = JSON.parse(localStorage.getItem("rvTabs"))[length - 1];
        if (tab["id"] == "globaloutlook") {
          // this.footerhide = 'footerhide';

          this.display = "none";
        }
      }
      this.footerloading = false;
      await this.featchfootermneu();
      this.footerloading = true;
      this.careerOpenNew();
    },

    careerOpenNew() {
      $(".rvheadermenu li:last-child")
        .find("img")
        .attr("alt", "ONEIL SECURITIES");
      $(".rvheadermenu li:last-child")
        .find("img")
        .attr("title", "ONEIL SECURITIES");
      $("a").each(function() {
        if ($(this).text() == "Careers") {
          $(this).attr("target", "_blank");
        }
      });
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/Footer.vue